__turbopack_context__.v({
  "arrow": "gfNujG_arrow",
  "interactiveContent": "gfNujG_interactiveContent",
  "interactiveDropdown": "gfNujG_interactiveDropdown",
  "tooltip": "gfNujG_tooltip",
});
